import axios from "axios";
import {  GetAllM24EmessiFiltersDTO, GetAllM24EmessiResponseData } from "./dto";
import { MonitoringM24EmessiService } from "./service";
import { keycloak } from "../../../../lib/keycloak";

export class MonitoringM24EmessiImpl implements MonitoringM24EmessiService {

    public GetAllM24Emessi(filters: GetAllM24EmessiFiltersDTO): Promise<GetAllM24EmessiResponseData[]> {
        return axios.get("/api/monitoring/starting-phase", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                from: filters.from ? filters.from : '',
                to: filters.to ? filters.to : ''
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}